<template>
  <generic-modal
    :title="$t('support list')"
    icon="list"
    image="/images/icons/support_control.png"
    v-bind:scrolling="false"
    v-on:destroy="destroy"
    v-bind:on_finished="this.finished"
  >
    <div class="description">
      <div class="ui relaxed selection divided list">
        <div
          class="item"
          v-for="(itm, idx) in service.sup_supports"
          :key="idx"
          @click="edit_support(itm)"
        >
          <i class="large olive bug middle aligned icon"></i>
          <div class="content">
            <div class="header">
              {{ $t("registered at") }}
              {{
                itm.create_date
                  | formatDate(enterprise_setup.second_detailed_date_format)
              }}
            </div>
            <div class="extra">
              {{
                itm.started_at
                  | formatDate(enterprise_setup.second_detailed_date_format)
              }}
              -
              {{
                itm.finished_at
                  | formatDate(enterprise_setup.second_detailed_date_format)
              }}
            </div>
            <div class="extra">
              {{ $t("total") }} {{ itm.elapsed_hours }} {{ $t("hours") }}
            </div>
            <div class="description">{{ itm.description }}</div>
          </div>
        </div>
      </div>
    </div>
  </generic-modal>
</template>

<script>
import moment from "moment";
import GenericModal from "@/components/GenericModal";
import filters from "@/filters";
import { enterprise_setup } from "@/utils";

export default {
  name: "SupportControlSupportListModal",
  components: {
    "generic-modal": GenericModal,
  },
  filters: filters,
  computed: {
    enterprise_setup() {
      return enterprise_setup(this);
    },
  },
  props: { service_in: Object },
  data() {
    return { service: {} };
  },
  methods: {
    finished() {
      return new Promise(function(resolve) {
        resolve();
      });
    },
    destroy() {
      this.$emit("destroy");
      // this.$destroy();
    },
    elapsed_hours(support) {
      let elapsed = "0";
      if (support.started_at && support.finished_at) {
        let start = moment(support.started_at);
        let end = moment(support.finished_at);
        elapsed = end.diff(start, "hours", true).toFixed(2);
      }

      return elapsed;
    },
    edit_support(support) {
      console.log(support);
    },
  },
  mounted() {},
  created() {
    this.service = this.service_in;
  },
  watch: {},
  updated: function() {},
};
</script>
